import { createContext, useContext, useState, ReactNode } from 'react'
import { BookingForm, DanceClass } from '../core'

interface BookingContextType {
  isBookingOpen: boolean
  setIsBookingOpen: (open: boolean) => void
  selectedClass: DanceClass | null
  setSelectedClass: (danceClass: DanceClass | null) => void
  bookingForm: BookingForm | null
  setBookingForm: (form: BookingForm | null) => void
  isDemo: boolean
  setIsDemo: (demo: boolean) => void
}

const BookingContext = createContext<BookingContextType | undefined>(undefined)

export function BookingProvider({ children }: { children: ReactNode }) {
  const [isBookingOpen, setIsBookingOpen] = useState(false)
  const [selectedClass, setSelectedClass] = useState<DanceClass | null>(null)
  const [bookingForm, setBookingForm] = useState<BookingForm | null>(null)
  const [isDemo, setIsDemo] = useState(false)

  return (
    <BookingContext.Provider
      value={{
        isBookingOpen,
        setIsBookingOpen,
        selectedClass,
        setSelectedClass,
        bookingForm,
        setBookingForm,
        isDemo,
        setIsDemo,
      }}
    >
      {children}
    </BookingContext.Provider>
  )
}

export function useBooking() {
  const context = useContext(BookingContext)
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider')
  }
  return context
}
